import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import HeaderFilter from "./HeaderFilter";
import ListGrid from "./ListGrid";
import {
  getWishlists,
  handleCreateWishlist,
  handleDelete,
  handleUpdate,
} from "./utils";
import Modal from "../general/Modal";
import CustomNotification from "../general/CustomNotification";
import { useModal } from "../../hooks/useModal";
import useNotifications from "../../hooks/useNotification";

const ListProducts = () => {
  const [searchValue, setSearchValue] = useState("");
  const [wishlists, setWishlists] = useState([]);
  const [filteredWishlists, setFilteredWishlists] = useState([]);
  const { modalData, openModal, closeModal, handleCancelClick } = useModal();
  const { notifications, addNotification, deleteNotification } = useNotifications();

  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  useEffect(() => {
    fetchWishlists();
  }, []);

  const fetchWishlists = async () => {
    try {
      const allWishlists = await getWishlists();
      setWishlists(allWishlists);
    } catch (error) {
      console.error("Error fetching wishlists:", error);
    }
  };

  const handleAddWishlist = async (wishlistName, addNotification) => {
    try {
      await handleCreateWishlist(wishlistName, addNotification);
      fetchWishlists();
    } catch (error) {
      console.error("Error adding wishlist", error);
    }
  };

  const handleDeleteWishlist = async (wishlistId, addNotification) => {
    try {
      await handleDelete(wishlistId, addNotification);
      fetchWishlists();
    } catch (error) {
      console.error("Error adding wishlist", error);
    }
  };

  const handleUpdateWishlist = async (
    wishlistName,
    wishlistId,
    addNotification
  ) => {
    try {
      await handleUpdate(wishlistName, wishlistId, addNotification);
      fetchWishlists();
    } catch (error) {
      console.error("Error adding wishlist", error);
    }
  };

  useEffect(() => {
    if (searchValue.trim() === "") {
      setFilteredWishlists(wishlists);
    } else {
      const filtered = wishlists.filter((wishlist) =>
        wishlist.name.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredWishlists(filtered);
    }
  }, [searchValue, wishlists]);

  return (
    <Container>
      <HeaderFilter
        searchBar
        placeholderSearchBar="Buscar wishlist"
        onSearchChange={handleSearchChange}
        showAddWishlist
        onAddWishlist={handleAddWishlist}
        onDeleteWishlist={handleDeleteWishlist}
        onUpdateWishlist={handleUpdateWishlist}
      />
      <ListGrid
        wishlists={filteredWishlists}
        onDeleteWishlist={handleDeleteWishlist}
        onUpdateWishlist={handleUpdateWishlist}
        openModal={openModal}
        closeModal={closeModal}
        addNotification={addNotification}
      />
      <Modal {...modalData} onClose={handleCancelClick} />
      <CustomNotification
        open={notifications.length > 0}
        alerts={notifications}
        deleteNotification={deleteNotification}
      />
    </Container>
  );
};

export default ListProducts;
